export const DEDICATED_WORKER_NAME = 'dedicatedWorker';
